export function isMainProduct(productType: string) {
  return productType === "product" || productType === "set";
}
